'use client';

import { Link } from '@/lib/mx-asurion-ui-react';
import { Modal } from '@asurion-core/aui-react-modal';
import { useState, type PropsWithChildren } from 'react';

export function SMSTermsAndConditions({ children }: PropsWithChildren) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Link color="secondary" onMouseDown={() => setIsModalOpen(true)}>
        {children}
      </Link>
      <Modal
        ariaLabel="SMS Terms and Conditions"
        isOpen={isModalOpen}
        onCloseModal={() => setIsModalOpen(false)}
      >
        <Modal.Header>
          <Modal.Title>SMS Terms and Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Content>
          Asurion sends Short Messaging Service (SMS) texts to customers to
          deliver important program information and other non-marketing messages
          about their account, including claim status updates, technical
          support, legal notices, and terms and conditions. Asurion also sends
          marketing offers and related content via SMS text message with the
          recipient&apos;s prior express written consent, which is not required
          to purchase Asurion services. Messages may be recurring or single use.
          For additional assistance or information, text HELP to 56699. To no
          longer receive particular SMS messages from Asurion, reply STOP to the
          applicable SMS message you receive. In addition to SMS messages,
          Asurion may also contact customers via live and automated
          (pre-recorded) voice messages. Data rates may apply.
        </Modal.Content>
      </Modal>
    </>
  );
}
